// To be deleted once all calculators are done with currency tier-1 adoptions
// Dependencies

import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

const Panel = (props) => {
  const classes = classnames('panel-container', props.className);

  return (
    <div style={props.style} className={classes}>
      {props.children}
    </div>
  );
};

Panel.displayName = 'Panel';

Panel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Panel.defaultProps = {
  className: null,
  style: {},
  children: null,
};

export default Panel;
